import * as Cookies from '../utils/cookies';
import axios from 'axios';

export async function getUserPlayerInfo() {
  try {
    const token = Cookies.getToken();

    const res = await axios({
      method: 'GET',
      url: process.env.REACT_APP_API_URL + '/api/users/users/home/',
      headers: { Authorization: `Bearer ${token}` },
    });

    if (res.status === 200) {
      return res.data;
    } else {
      return { error: res.status };
    }
  } catch (error) {
    return { error  };
  }

}
